import { createAction } from 'redux-actions';

export const getGoals = createAction('GET_GOALS');
export const getGoalsSuccess = createAction('GET_GOALS_SUCCESS');
export const getGoalsFailure = createAction('GET_GOALS_FAILURE');

export const createGoal = createAction('CREATE_GOAL', (payload) => payload, (payload, metadata) => metadata);
export const createGoalSuccess = createAction('CREATE_GOAL_SUCCESS', (payload) => payload, (payload, metadata) => metadata);
export const createGoalFailure = createAction('CREATE_GOAL_FAILURE');

export const updateGoal = createAction('UPDATE_GOAL', (payload) => payload, (payload, metadata) => metadata);
export const updateGoalSuccess = createAction('UPDATE_GOAL_SUCCESS');
export const updateGoalFailure = createAction('UPDATE_GOAL_FAILURE');

export const deleteGoal = createAction('DELETE_GOAL', (payload) => payload, (payload, metadata) => metadata);
export const deleteGoalSuccess = createAction('DELETE_GOAL_SUCCESS');
export const deleteGoalFailure = createAction('DELETE_GOAL_FAILURE');